import { render, staticRenderFns } from "./BloodOxygenReportPrint.vue?vue&type=template&id=a75834f8&scoped=true"
import script from "./BloodOxygenReportPrint.vue?vue&type=script&lang=js"
export * from "./BloodOxygenReportPrint.vue?vue&type=script&lang=js"
import style0 from "./BloodOxygenReportPrint.vue?vue&type=style&index=0&id=a75834f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75834f8",
  null
  
)

export default component.exports